module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path !== '/intro'),
      expression: "$route.path !== '/intro'"
    }],
    staticClass: "picker-nav toolbar"
  }, [_c('a', {
    staticClass: "branding",
    attrs: {
      "href": "/"
    },
    on: {
      "click": _vm.clearLocalStorage
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/SPBeta_Logo.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "info-button",
    attrs: {
      "href": "https://blog.data.gov.sg/find-the-right-school-using-our-new-school-picker-tool-3a7250b63390"
    }
  }, [_vm._v("i")]), _vm._v(" "), _c('div', {
    staticClass: "bookmark-button desktop-only",
    class: {
      'bg-positive': _vm.bookmarkActive, 'text-white': _vm.bookmarkActive
    },
    on: {
      "click": _vm.route
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/Star_White.svg"
    }
  }), _vm._v("BOOKMARK\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBookmark & !_vm.bookmarkActive),
      expression: "hasBookmark & !bookmarkActive"
    }],
    staticClass: "bookmark-indicator bg-positive"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookmark-toggle mobile-only",
    on: {
      "click": _vm.route
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bookmarkActive ? '/assets/Star_Green_Solid.svg' : '/assets/Star_White.svg'
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBookmark & !_vm.bookmarkActive),
      expression: "hasBookmark & !bookmarkActive"
    }],
    staticClass: "bookmark-indicator bg-positive"
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13d8b273", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13d8b273!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavView/index.vue
// module id = 842
// module chunks = 0